import { useState } from "react";
import { HiUserGroup } from "react-icons/hi";
import { resolveFileUrl } from "../../utils/fileUrl";

const PALETTE = [
  "from-blue-500 to-indigo-500",
  "from-emerald-500 to-teal-500",
  "from-amber-500 to-orange-500",
  "from-rose-500 to-pink-500",
  "from-violet-500 to-purple-500",
  "from-cyan-500 to-sky-500",
];

const SIZES = {
  xs: { box: "w-6 h-6 text-[10px]", dot: "w-2 h-2" },
  sm: { box: "w-8 h-8 text-xs", dot: "w-2.5 h-2.5" },
  md: { box: "w-10 h-10 text-sm", dot: "w-3 h-3" },
  lg: { box: "w-14 h-14 text-lg", dot: "w-3.5 h-3.5" },
  xl: { box: "w-28 h-28 text-3xl", dot: "w-5 h-5" },
};

export const initials = (name = "") =>
  name
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("") || "?";

// A person's profile photo, falling back to coloured initials (stable colour per user id).
// `online` adds a presence dot when it is a boolean; `group` shows a group icon instead of initials.
function UserAvatar({ name, src, seed = 0, size = "md", online, group = false, className = "" }) {
  const [failedSrc, setFailedSrc] = useState(null);
  const { box, dot } = SIZES[size] || SIZES.md;
  const colour = PALETTE[Math.abs(Number(seed) || 0) % PALETTE.length];
  const url = resolveFileUrl(src);
  const showPhoto = url && failedSrc !== url;

  return (
    <div className={`relative shrink-0 ${box} ${className}`}>
      {showPhoto ? (
        <img
          src={url}
          alt=""
          onError={() => setFailedSrc(url)}
          className="w-full h-full rounded-full object-cover bg-gray-100 dark:bg-gray-800"
          loading="lazy"
          draggable={false}
        />
      ) : (
        <div
          className={`w-full h-full rounded-full bg-gradient-to-br ${colour} text-white font-semibold flex items-center justify-center select-none`}
          aria-hidden="true"
        >
          {group ? <HiUserGroup className="w-1/2 h-1/2" /> : initials(name)}
        </div>
      )}
      {typeof online === "boolean" && (
        <span
          className={`absolute bottom-0 right-0 block rounded-full ring-2 ring-white dark:ring-gray-900 ${dot} ${online ? "bg-green-500" : "bg-gray-400"}`}
          title={online ? "Online" : "Offline"}
        />
      )}
    </div>
  );
}

export default UserAvatar;
